import { Divider } from "@mui/material";
import * as React from "react";
import { useContext } from "react";
import { GroupChatListPanelHeader } from "../../GroupChatListPanelHeader";
import InternalGroupChatList from "./InternalGroupChatList";
import { FilteredInternalChatsContext } from "hhn-commons";
import { GroupChatListPanelHeaderWrapper } from "../patient/PatientChats.styles";

type InternalChatListSearchViewProps = {
  selectedChatId?: string;
};

export const InternalChatListSearchView = ({
  selectedChatId,
}: InternalChatListSearchViewProps) => {
  const { chatData, isChatLoading, fetchChats } = useContext(
    FilteredInternalChatsContext,
  );

  return (
    <>
      <Divider />
      <GroupChatListPanelHeaderWrapper>
        <GroupChatListPanelHeader
          unreadChatCount={chatData?.unreadChatCount || 0}
          searchResultCount={chatData?.searchMatchCount}
          listSize={(chatData?.chats || []).length}
        />
      </GroupChatListPanelHeaderWrapper>
      <Divider />
      <InternalGroupChatList
        chats={chatData?.chats || []}
        selectedChatId={selectedChatId}
        isChatLoading={isChatLoading}
        fetchChatList={fetchChats}
        isMoreChats={chatData?.hasNext}
      />
    </>
  );
};
